import { inject, observer } from "mobx-react";
import React from "react";

@inject(({ popupStore }) => ({ popupStore }))
@observer
class MentorCommissionButton extends React.Component {

    mentorCommissionPopup = () => {
        const { balance, info } = this.props
        const type = balance === 'CREDIT' ? 'mentorCreditCommission' :'mentorDebtCommission'
        this.props.popupStore.togglePopup(type, {
            agentInfo: info.agentInfo,
            clientAgentInfo: info
        })
    }

    render () {
        if (!this.props.info.selectedClient.client_id) {
            return ''
        }
        return (
            <span
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={this.mentorCommissionPopup}    
            >
                {"עמלת מנטור"}
            </span>
        )
    }
}

export default MentorCommissionButton